// extracted by mini-css-extract-plugin
module.exports = {"input-edit":"index__input-edit__2lx7T","btn":"index__btn__1TsRq","btn-cancel":"index__btn-cancel__2P61u","btn-confirm":"index__btn-confirm__1OaX-"};